export default {
  init() {

  },
  finalize() {

    const $filterWrap = $('.bits-latest-events-filters');

    var reloadRequested = false;
    var reloadRequestedTime = 0;

    // Sets the input value based on filters selected for GET
    function updateFormInput(reload = false) {

      var slugs = '';

      // Iterate through all filter items that are selected
      $filterWrap.find('.valley-filter-item.selected').each(function() {

        // If this is a parent, only proceed IF this has no children
        if (($(this).hasClass('valley-filter-parent-item') && $(this).siblings('.valley-filter-children').find('.valley-filter-child-item').length == 0)
          || (!$(this).hasClass('valley-filter-parent-item'))) {

          slugs += $(this).find('.valley-filter-checkbox').data('slug') + '+';
          
        }

        if (slugs.substring(-1) == '+') {
          slugs = slugs.slice(0, -1);
        }

      });

      $filterWrap.find('input[name="valleys"]').prop('value', slugs);

      if (reload) {
        // Wait 3 seconds, if no changes have been made, reload (save the filter selection)
        reloadRequested = true;

        const time = (new Date()).getTime();
        reloadRequestedTime = time;

        setTimeout(() => {
          if (reloadRequested && reloadRequestedTime == time) {
            $filterWrap.find('#latest-events-filter-form').submit();
          }
        }, 3000);
      }

    }

    // Sets the correct classes for the filters
    function updateFilterVisuals(reload = false) {

      // Iterate through all parent items
      $filterWrap.find('.valley-filter-parent-item').each(function() {

        const $children = $(this).siblings('.valley-filter-children').find('.valley-filter-child-item');
        const childrenCount = $children.length;
        var childrenSelectedCount = 0;

        $children.each(function() {
          if ($(this).hasClass('selected')) {
            childrenSelectedCount++;
          }
        });

        if (childrenSelectedCount == 0) {
          // No children selected
          $(this).removeClass('selected');
          $(this).removeClass('partial-selected');
        } else if (childrenSelectedCount < childrenCount) {
          // Partial children selected
          $(this).removeClass('selected');
          $(this).addClass('partial-selected');
          $(this).parent().addClass('expanded');
          $(this).siblings('.valley-filter-children').stop().slideDown(200);
        } else {
          // All children selected
          $(this).removeClass('partial-selected');
          $(this).addClass('selected');
          $(this).parent().addClass('expanded');
          $(this).siblings('.valley-filter-children').stop().slideDown(200);
        }

      });

      updateFormInput(reload);

    }

    updateFilterVisuals();

    // Child checkbox click
    $filterWrap.find('.valley-filter-child-checkbox').on('click', function() {
      $(this).parent().toggleClass('selected');
      updateFilterVisuals(true);
    });

    // Parent checkbox click
    $filterWrap.find('.valley-filter-parent-checkbox').on('click', function() {
      if ($(this).parent().hasClass('selected')) {
        // Currently on selected, de-select all children now
        $(this).parent().siblings('.valley-filter-children').find('.valley-filter-child-item').removeClass('selected');
      } else {
        // Select all children now
        $(this).parent().siblings('.valley-filter-children').find('.valley-filter-child-item').addClass('selected');
      }
      
      updateFilterVisuals(true);
    });

    // Expand / collapse children
    $filterWrap.find('.valley-filter-expander').on('click', function() {
      $(this).parent().parent().toggleClass('expanded');
      $(this).parent().siblings('.valley-filter-children').stop().slideToggle(200);
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/bits/latestEventsFilter.js